import * as React from 'react';
import * as styles from './styles.css';

import { Spinner } from '@cian/ui-kit';

export const Preloader: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="market_price_preloader">
      <Spinner size={32} />
    </div>
  );
};

Preloader.displayName = 'Preloader';
